var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation',{staticClass:"potato-navigation"}),_c('sidebar',{staticClass:"potato-sidebar"}),_c('p-footer',{staticClass:"pototo-footer"}),_c('router-view',{staticClass:"potato-editor"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }